import { z } from 'zod';

export const TimeToSubmissionSchema = z.object({
  hours: z.number(),
  isSubmitted: z.boolean(),
});

export type TimeToSubmission = z.infer<typeof TimeToSubmissionSchema>;
